import Entity from '../entity'

export default class Page extends Entity<number>{
    title: string;
    content: string;
    active: boolean;
}


